import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/categories/new/loading';

export const Route = createFileRoute('/_private/settings/categories/new')({
  component: Loading,
});
